import styles from './OrderSimCard.module.css'
import {useDispatch, useSelector} from "react-redux";
import {ActionMessageInt, ReduxStateInt, setBaseRegion, setOrderData, setSlider} from "../Reducer/GlobalReducer";
import RegionChange from "../RegionChange/RegionChange";
import React, {useEffect, useRef, useState} from "react";
import {Button} from "react-bootstrap";
import {Link, useNavigate} from "react-router-dom";
import RegModeOne from "./RegModeOne/RegModeOne";
import useApiQuery from "../ApiQuery/UseApiQuery";
import Slide from "../Slider/Slide";
import RegModeMnp from "./RegModeMnp/RegModeMnp";
import ErrorLineItem, {ErrorLineItemRef} from "../FormTemplate/ErrorLineItem/ErrorLineItem";
import RegModeSelf from "./RegModeSelf/RegModeSelf";
import {Helmet} from "react-helmet";
import WaitLoader from "../WaitLoader/WaitLoader";
import Coupon from "./Coupon/Coupon";
import InputItemLight from "../FormTemplate/InputItemLight/InputItemLight";
import {async, Subscription} from "rxjs";
import {deflateRaw} from "zlib";

interface CreateOrderInt
{
    tarifId: string
    macroRegionId: number
    regionId: number
    regMode:number
    sameOper:boolean
    mnpCtn?:string
    couponId?:string
    softCoupon?:string
    srcOper?:string
    srcRegion?: string
}

interface IUseCoupon
{
    orderId?: string
    sessionId?:string
    couponId:string
}


export default function OrderSimCard() {

    const rxObserve = useSelector((state: ReduxStateInt) => {
        return state.rxObserve
    })
    const subscriber = useRef<Subscription>()


    const wrapperRef = useRef<HTMLDivElement>(null);
    const regionRef = useRef<HTMLDivElement>(null);

    const baseUrl = useSelector((state: ReduxStateInt) => {
        return state.baseUrl
    })

    const orderData = useSelector((state: ReduxStateInt) => {
        return state.orderData
    })

    const slider = useSelector((state: ReduxStateInt) => {
        return state.slider
    })

    const orderCont = useRef<HTMLDivElement>(null)

    const refState = useRef<ErrorLineItemRef>(null)
    const refCouponState = useRef<ErrorLineItemRef>(null)

    const [useSelfReg, setUseSelfReg] = useState(false)
    const [showNoteSelfReg , setShowNoteSelfReg] = useState(false)

    const [regMode, setRegMode] = useState(0)

    const [coupon, setCoupon] = useState<string|undefined>(undefined)

    const [created, setCreated] = useState(false)

    const createOrderData = useRef<CreateOrderInt>()
    const [ldrCreateOrder,rsCreateOrder,exCreateOrder] = useApiQuery("/sell/sim/order/create","post",createOrderData);

    const couponData = useRef<IUseCoupon>()
    const [ldrCoupon,rsCoupon,exCoupon] = useApiQuery("/sell/sim/order/coupon/apply","post",couponData);

    const [couponApplied, setCouponApplied] = useState(false)
    const [couponLink, setCouponLink] = useState<string>()
    const [couponId, setCouponId] = useState<string>()

    const dispatch = useDispatch();

    const tarifData = useRef({
        regionId:-1,
        macroRegionId: -1,
        tarifId:""
    })
    const [ldrTarif,rsTarif,exTarif] = useApiQuery("/tarif/list","post",tarifData);

    const [maxBlockWidth , setMaxBlockWidth] = useState<string>("800px")

    const [couponErrorCode, setCouponErrorCode] = useState(-1)

    const [cardData, setCardData] = useState({})


    const navigate = useNavigate()

    const dataCardItem = useSelector((state: ReduxStateInt) => {
        return state.slider.dataCardItem
    })

    const isRegionSelected = useSelector((state: ReduxStateInt) => {
        return state.baseRegion.isChanged
    })
    const region = useSelector((state: ReduxStateInt) => {
        return state.baseRegion
    })

    const [mode, setMode] = useState(region?.isChanged ? 1:0)


    useEffect(()=>{
        if(coupon) setCouponId(coupon)
    },[coupon])


    useEffect(()=>{
        if(subscriber.current)
        {
            try {
                subscriber.current?.unsubscribe()
            } catch (e) {

            }
        }
        //console.log(`Slider ${id.current} add subscriber`)
        subscriber.current = rxObserve.subscribe((e)=>messageMake(e))
        return ()=>{
            //console.log(`Slider ${id.current} remove subscriber`)
            if(subscriber.current)subscriber.current?.unsubscribe()
        }
    })


    useEffect(()=>{
        setTimeout(()=>{
//            console.log("switch view",orderCont.current)
            if(orderCont.current)orderCont.current.scrollIntoView()
        },500)
        switch (mode)
        {
            case 0:
                if(regionRef.current)regionRef.current.scrollIntoView()
                break
            case 1:
                loadTarif()
                break
        }

        //if(refCouponState.current)refCouponState.current.show("Этот купон здесь не действуеь", true,0)

    },[mode,region.regionId])

    useEffect(()=>{
            //console.log("switch view eff",orderCont.current)
            if(orderCont.current)orderCont.current.scrollIntoView()

    },[orderCont.current])


    useEffect(()=>{

        if(region.isChanged)
        {
            setMode(1)
            setCreated(false)
            //createOrder()
        }

    },[dataCardItem,region])

    useEffect(()=>{
        setRegMode(dataCardItem?.regMode)
        //console.log("Сменилась карточка",dataCardItem)
    },[dataCardItem])


    const messageMake = (message: ActionMessageInt) =>{
        if(message?.message?.match(/orderBlock-width/ui))
        {
            console.log(message)
            setMaxBlockWidth(message?.data)
            return
        }


    }

    const loadTarif = () =>{
        if(!region.isChanged) return

        if(!dataCardItem?.tarifId)navigate('/')//Не выбран тариф

        tarifData.current.regionId = region?.regionId ?  region?.regionId : -1
        tarifData.current.macroRegionId = region?.macroRegionId ?  region?.macroRegionId : -1
        tarifData.current.tarifId = dataCardItem?.tarifId ? dataCardItem?.tarifId : ""
        exTarif().then((e)=>{
            if(e?.success)
            {
                if(e?.payload && Array.isArray(e?.payload) && e?.payload?.length > 0 )
                {
                    const pr = e?.payload[0]
                    setCardData(pr)
                    setMode(1) //Есть тариф
                    return
                }
                setMode(6)//Нет тарифа
                return;
            }
            if(refState.current)refState.current.show(e?.errorAsString ?  e?.errorAsString : "Ошибка сервера",true,3000)

        })

    }



    function useOutsideAlerter(ref:any) {
        useEffect(() => {
            /**
             * Alert if clicked on outside of element
             */
            function handleClickOutside(event:any) {
                if (ref.current && !ref.current.contains(event.target)) {
                    //console.log(`You clicked outside of me! ${capt}`);
                    setShowNoteSelfReg(false)
                }
            }
            // Bind the event listener
            document.addEventListener("mousedown", handleClickOutside);
            return () => {
                // Unbind the event listener on clean up
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [ref]);
    }



    const buildSelfRegItem = () =>{
        if(!dataCardItem?.canSelfReg) return null
        if(dataCardItem?.regMode === 1) return null
        if(dataCardItem?.regMode === 10) return null
        return (
            <div className={styles.selfCover}>
                <div className={styles.selfCont}>
                    <input className="form-check-input" type="checkbox" id="gridCheck"
                           checked={useSelfReg}
                           onChange={()=>setUseSelfReg(!useSelfReg)}

                    ></input>
                    <label className="form-check-label " htmlFor="gridCheck">
                        <div>Использовать саморегистрацию</div>
                    </label>
                </div>
                <div style={{position:"relative",display:"flex"}}>
                    <div className={styles.selfNote} onClick={()=>{
                        setShowNoteSelfReg(true)
                        setTimeout(()=>setShowNoteSelfReg(false),10000)
                    }}>Прочти, что это такое ?</div>
                    {showNoteSelfReg &&
                        <div ref={wrapperRef} className={styles.selfNoteCont}>
                            Вам не нужно отправлять нам свои персональные данные, Вы можете сами зарегистрировать SIM карту при получении - через Ваши «Госуслуги» и «Госключ»
                        </div>
                    }

                </div>

            </div>
        )
    }



    useOutsideAlerter(wrapperRef);

    const buildRegMode = ()=>{
        console.log(`SWITCH ${mode} ${regMode}`)
        switch (regMode)
        {
            case 0: return <RegModeOne></RegModeOne>
            case 1: return <RegModeSelf></RegModeSelf>
            //case 2: return <RegModeSelf></RegModeSelf>
            case 10: return <RegModeMnp></RegModeMnp>
            default: return (
                <div>Не известный режим подключения</div>
            )
        }
    }


    const buildCouponItem = () =>{
        return(
            <div className={styles.cpCont}>
                <div className={styles.cpTitle}>
                    Если у Вас есть купон [промокод] на скидку, введите его
                </div>
                <div className={styles.cpInputCnt}>
                    <input
                        className={["form-control form-control-sm"].join(' ')}
                        placeholder={"Купон"}
                        value={coupon ? coupon : ""}
                        maxLength={15}

                        onChange={(e)=>{
                            const x = e?.target?.value ? e?.target?.value?.toString() : undefined
                            setCoupon(x)
                            setCouponErrorCode(-1)
                        }}
                        onBlur={(e)=>{
                            const x = e?.target?.value ? e?.target?.value?.toString()?.trim() : undefined
                            console.log("blur ", x)
                            setCoupon(x)
                        }}
                        onKeyDown={(e)=>{
                            if(e?.key === "Enter" && coupon && coupon?.length > 2) handleNext().catch()
                        }}

                    />
                </div>

                <div className={ styles.stCont}>
                    <ErrorLineItem ref={refCouponState} />
                </div>

                { couponErrorCode === 404 &&
                    <div className={[styles.cpError404, styles.ramka5].join(' ')}>Введите купон заново или продолжите без купона</div>
                }

                { couponErrorCode === 406 && couponLink &&
                    <div className={[styles.cpError406].join(' ')}>
                        <div>Тарифы для купона {couponId}</div>
                        <Link to={couponLink} target={"_blank"} className={styles.cpError406Link}>
                            <div >просмотр</div>
                        </Link>
                    </div>
                }



            </div>
        )
    }


    async function createOrderMain(){
            // if(errorLineRef.current)errorLineRef.current.show("Создаю заказ",false,3000)

            let regMode = dataCardItem?.regMode
            if(dataCardItem?.canSelfReg && useSelfReg) regMode = 1 //self reg
            //if(dataCardItem?.regMode === 2 ) regMode = 1 //Саморег
            const sameOper = regMode !== 10 ? false : orderData?.mnpData?.sameOper !== undefined ? orderData?.mnpData?.sameOper : false
            const srcOper = regMode === 10 && orderData?.mnpData?.srcOper ? orderData?.mnpData?.srcOper : undefined
            const srcRegion = regMode === 10 && orderData?.mnpData?.srcRegion ? orderData?.mnpData?.srcRegion : undefined
            createOrderData.current = {
                macroRegionId: region?.macroRegionId !==undefined ? region?.macroRegionId : -1,
//            regMode: dataCardItem?.regMode !==undefined ? dataCardItem?.regMode : -1,
                regMode: regMode,
                regionId: region?.regionId !==undefined ? region?.regionId : -1,
                tarifId: dataCardItem?.tarifId ? dataCardItem?.tarifId : "",
                softCoupon: slider?.softCoupon ? slider?.softCoupon : undefined,
                sameOper: sameOper,
                srcOper: srcOper,
                srcRegion: srcRegion
            }
            if(createOrderData.current?.regMode === 10)
            {
                createOrderData.current = { ...createOrderData.current,
                    mnpCtn:  orderData?.mnpData?.ctn ? orderData?.mnpData?.ctn : "unknown"
                }
            }

            console.log("create order data ",createOrderData.current)
            setRegMode(regMode)

            return exCreateOrder()

    }
    async function applyCoupon(){
        if(refCouponState.current)refCouponState.current.clear()
        setCouponErrorCode(-1)
        return exCoupon()
    }

    async function handleNext(){
        if(! dataCardItem?.tarifId  ||  dataCardItem?.regMode === undefined) navigate('/')
        if(!isRegionSelected) return null
        console.log("create order dataCardItem ",dataCardItem)
        if(! created){
            createOrderMain().then((e)=>{
                if(e?.success)
                {
                    let xData = {
                        tarifData : {
                            operId: dataCardItem?.operId,
                            tarifId: dataCardItem?.tarifId,
                            name: dataCardItem?.name,
                            price: dataCardItem?.price,
                            bundleId: dataCardItem?.bundleId,
                            operName: dataCardItem?.operOne?.name,
                            newPrice: undefined
                        },
                        regionData: {
                            macroRegionId:region?.macroRegionId,
                            regionId: region?.regionId,
                            macroRegionName: region?.macroRegionName,

                        },
                        regMode: regMode,
                        orderId: e.payload.orderId,
                        sessionId: e.payload.sessionId,
                        couponId: undefined

                    }
                    dispatch(setOrderData(xData))
                    //setMode(2) //Переходим к след этапу
                    setCreated(true)

                    if(coupon){
                        couponData.current = {
                            orderId: xData?.orderId,
                            sessionId : xData?.sessionId,
                            couponId: coupon
                        }
                        applyCoupon().then((e)=>{
                            if(e?.success){

                                dispatch(setOrderData({...xData,tarifData: {...xData?.tarifData, newPrice: e?.payload?.newPrice}, couponId: coupon }))
                                setMode(2)
                                setCouponApplied(true)
                                return
                            }
                            if(refCouponState.current)refCouponState.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера", true,0)
                            setCoupon(undefined)
                            setCouponErrorCode(e?.code !== undefined ? e?.code : -1)
                            setCouponLink(e?.payload?.link ? e?.payload?.link : undefined)
                        }).catch()


                    } else setMode(2)
                    return

                }
                setCreated(false)
                if(refState.current)refState.current.show(e?.errorAsString ?  e?.errorAsString : "Ошибка сервера",true,3000)

            })
            return

        }


        if(coupon && orderData?.orderId && orderData?.sessionId && !couponApplied){
            couponData.current = {
                orderId: orderData?.orderId,
                sessionId : orderData?.sessionId,
                couponId: coupon
            }
            const xData = orderData
            applyCoupon().then((e)=>{
                if(e?.success){
                    dispatch(setOrderData({...xData,tarifData: {...xData?.tarifData, newPrice: e?.payload?.newPrice}, couponId: coupon }))
                    setMode(2)
                    return
                }
                if(refCouponState.current)refCouponState.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера", true,0)
                setCoupon(undefined)
                setCouponErrorCode(e?.code !== undefined ? e?.code : -1)
                setCouponLink(e?.payload?.link ? e?.payload?.link : undefined)


            }).catch()


        } else setMode(2)
    }

    return (
        <div className={styles.mainCont} ref={orderCont}>

            <Helmet>
                <title>sim-unlim : Заказ [ {dataCardItem?.name ? dataCardItem?.name :""} ]</title>
                <link rel="canonical" href="https://sim-unlim.com/order" />
                <meta name="description" content={["заказ тариф",dataCardItem?.name].join(' ')} />
            </Helmet>

            {/* Режим не выбран регион */}
            {mode===0 &&
                <div ref={regionRef} className={[styles.orderCont,styles.orderContBorder, styles.wideText].join(' ')}  >
                    <p className={styles.regText}>Для продолжения подключения Вам нужно выбрать регион Вашего нахождения, Это нужно для корректного выбора номера и
                        правильности работы тарифа в Вашем регионе, а так же верным параметрам тарифа в регионе. При выборе региона, могут изменится параметры тарифного плана, а так же возможность его подключения в принципе,
                        После выбора региона Вам отобразятся корректные параметры тарифного плана.
                    </p>

                    <div className={styles.btnSelect}
                         onClick={() => dispatch(setBaseRegion({makeSelectRegion: true}))}
                    >Выбрать регион
                    </div>

                </div>
            }

            {/* Основной вид */}
            {mode===1 &&

                <div className={styles.ordBlock}>
                    <div className={[styles.orderCont].join(' ')} >
                        <div className={styles.regCont} >
                            <div className={styles.tfWar}>Выбранный тарифный план в регионе </div>
                            <div className={styles.tfWar}>[ {region.regionName} ]</div>
                        </div>

                        <div className={styles.slideCont}>
                            <Slide
                                item={cardData}
                                key={0}
                                showConnect={false}
                            />

                        </div>


                        {buildSelfRegItem()}

                        {buildCouponItem()}




                        <div className={styles.ftCont}>
                            <div className={styles.tfWar}>
                                Нажимая кнопку продолжить, Вы соглашаетесь с условиями <a className={styles.ofLink} href={baseUrl+'/static/offer.docx'}>оферты</a> и тарифным планом
                            </div>
                        </div>

                        <div className={styles.btnCont}>

                            <button type="button" className="btn btn-face "
                                    disabled={ldrCoupon || ldrCreateOrder}
                                    onClick={()=>{
                                        dispatch(setSlider({sliderMode:0}))
                                        navigate('/')
                                    }}
                            >Отменить</button>

                            <button type="button" className="btn btn-face "
                                    disabled={ldrCoupon || ldrCreateOrder}
                                    onClick={()=>handleNext()}
                            >Продолжить</button>

                        </div>



                    </div>

                </div>
            }

            {/* Следующий шаг */}
            {mode === 2 &&
                <div className={styles.ordBlock} style={{maxWidth: maxBlockWidth}}>
                    <div className={styles.orderCont}>

                        {buildRegMode()}

                    </div>

                </div>
            }


            {/* Тариф не доступен в регионе */}
            {mode === 6 &&
                <div className={styles.orderCont}>
                    <div style={{textAlign:"center"}}>К сожалению в Вашем регионе данный тариф не доступен, выберите другой тариф уже согласно Вашему региону</div>

                    <div className={styles.btnCont}>
                        <div className={styles.btnSelect}
                             onClick={() => navigate("/")}
                        >Главная
                        </div>
                    </div>

                </div>
            }
            <ErrorLineItem ref={refState} ></ErrorLineItem>



        </div>
    )

}
